import styled from 'styled-components';
import { ArticleCard } from '../article-card';
import { Box } from '@vinomofo/components';

export const ArticleCardGroup = ({ hits, rowNumber, containerRef, position, maxHeight }: { hits: any, rowNumber: number, containerRef: any, position: string, maxHeight: number}) => {
    const Container = styled(Box) <{ maxHeight: string; position: string; top: string }>`
  font-family: "Graphik", sans-serif;
  position: ${({ position }) => position};
  top: ${({ top }) => top};
  left: 0;
  right: 0;
  display: grid;

  background: white;
  z-index: 99;
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-x: hidden;

  grid-template-columns: repeat(${rowNumber}, 1fr);
  gap: 18px;
  padding: 16px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  @media (max-width: 468px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  }
`;
    return <Container
    ref={containerRef}
    backgroundColor="white"
    borderRadius="5px"
    marginTop="20px"
    overflow=""
    position={position}
    maxHeight={maxHeight}
  >
    {hits.map((hit) => (
      <ArticleCard hit={hit}/>
    ))}
  </Container>
}